








import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import UrlMixin from '@/mixins/url';

@Component
export default class Logo extends mixins(UrlMixin) {
  @Prop() private text!: string;
}
